var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<support-message></support-message><div class=\"modal-header\"><h4 class=\"modal-title\">Identification Failure</h4></div><div class=\"modal-body\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><p class=\"strong\">Hmmm. Unfortunately Experian wasn't able to verify your identity using the answers you provided.</p><p>You can try again if you think there was an error.</p><p>However, after multiple failed attempts, the automated verification option may no longer\nbe available. If that happens, you'll have to email us at&nbsp;<a href=\"mailto:{{SUPPORT_EMAIL}}\" class=\"underline\">{{SUPPORT_EMAIL}}</a>&nbsp;in order to verify your account for credit reports</p></div></div></div></div><div class=\"modal-footer\"><button ng-click=\"$close()\" class=\"btn btn-primary\">Ok, I understand</button></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./services/experian/failure/failure.jade
// module id = 227
// module chunks = 0